import * as Views from '@views/index'

export const ROUTE_LOADER = {
    element: <Views.Loader />,
    path: '/'
}

export const ROUTE_AUTH = {
    element: <Views.Auth />,
    path: '/auth'
}

export const ROUTE_AUTH_LOGIN = {
    element: <Views.Auth />,
    path: '/auth/login'
}

export const ROUTE_HOME = {
    element: <Views.Home />,
    path: '/home'
}

export const ROUTE_LANDING_ZONES = {
    element: <Views.Landingzones />,
    path: '/landing-zones'
}

export const ROUTE_LANDING_ZONES_ID = {
    element: <Views.Landingzones />,
    path: '/landing-zones/:id'
}

export const ROUTE_LANDING_ZONES_ID_MODE = {
    element: <Views.Landingzones />,
    path: '/landing-zones/:id/:mode'
}

export const ROUTE_LOGS = {
    element: <Views.Logs />,
    path: '/logs'
}

export const ROUTE_LOGS_MODE = {
    element: <Views.Logs />,
    path: '/logs/:mode'
}

export const ROUTE_NOT_FOUND = {
    element: <Views.NotFound />,
    path: '*'
}

export const routes = [
    ROUTE_LOADER,
    ROUTE_NOT_FOUND,
    ROUTE_HOME,
    ROUTE_AUTH,
    ROUTE_AUTH_LOGIN,
    ROUTE_LANDING_ZONES,
    ROUTE_LANDING_ZONES_ID,
    ROUTE_LANDING_ZONES_ID_MODE,
    ROUTE_LOGS,
    ROUTE_LOGS_MODE
]
